async function useCustomerPoint(usePoint) {
    const { point, discountCode } = await _vip_my_sdk.customerPointUse({ point: usePoint });
    $('.cart__ctas').fadeIn();
  };
async function checkPriceHasPoint() {
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
      console.log(data['items']);
    var total_cart_price = 0;
    for (var i in data['items']) {
      var row_price = data['items'][i].original_price / 100;
      row_price = row_price * data['items'][i].quantity;
      total_cart_price += row_price;
    }
    var product_price = $('.price__container .price-item.price-item--regular').html();
    product_price = parseInt(product_price.replace('製品分', ''));
    if ((_sp_haspoint - product_price - total_cart_price) > -1) {
      $('#product_detail_buy_button').css({'display': 'block'});
    }
  })
  .catch((error) => {
      console.error('Error:', error);
    return false;
  });
};

jQuery(function($){
  /*  shadowdom取得  */
  $.shadowDom = function(selector, context){
  	context = context || document;
  	var docs = [context];
  	dig(context);
  	var result = $();
  	docs.forEach(function(doc){
  		Array.apply(null, doc.querySelectorAll(selector)).forEach(function(dom){
  			result = result.add(dom);
  		});
  	});
  	return result;
  	function dig(doc){
  		Array.apply(null, doc.querySelectorAll('*')).forEach(function(dom){
  			if(dom.shadowRoot!=null){
  				docs.push(dom.shadowRoot);
  				dig(dom.shadowRoot);
  			}
  		})
  	}
  };

  //商品一覧  商品詳細  価格書き換え
  $(window).on('load', function(){
    var product_list_price = $('.price-item.price-item--regular');
    if (product_list_price.length && $('html').attr('lang') != 'ja') {
      product_list_price.each(function(){
        replacePriceUnit($(this), $('html').attr('lang'));
      });
    }
    if ($('#cart').length && $('html').attr('lang') != 'ja') {
      var item1 = $('.cart-item__details .product-option');
      if (item1.length) {replacePriceUnit(item1, $('html').attr('lang'));}
      var item2 = $('.cart-item__price-wrapper .price.price--end');
      if (item2.length) {replacePriceUnit(item2, $('html').attr('lang'));}
      var item3 = $('.totals .totals__total-value');
      if (item3.length) {replacePriceUnit(item3, $('html').attr('lang'));}
    }
    var shadow_html4 = $.shadowDom('#FacetFiltersForm .facets__selected')
    if (shadow_html4.length && $('html').attr('lang') != 'ja') {
      if (shadow_html4.length) {replacePriceUnit(shadow_html4, $('html').attr('lang'));}
    }
    var shadow_html5 = $.shadowDom('#FacetsWrapperMobile .mobile-facets__info')
    if (shadow_html5.length && $('html').attr('lang') != 'ja') {
      if (shadow_html5.length) {replacePriceUnit(shadow_html5, $('html').attr('lang'));}
    }
  });
  var replacePriceUnit = function (elm, lang) {
    elm.each(function(){
      var product_price = $(this).html();
      if (lang == 'en') {
        product_price = product_price.replace('製品分', 'Quantity of applicable items');
      } else if (lang == 'ko') {
        product_price = product_price.replace('製品分', '대상품 수량');
      } else if (lang == 'zh-CN') {
        product_price = product_price.replace('製品分', 'Point');
      } else if (lang == 'zh-TW') {
        product_price = product_price.replace('製品分', '適用產品數量');
      }
      $(this).html(product_price);
    });
  }
  var getCartTotalPrice = function(){
    var total = 0;
    $('.cart__items table.cart-items .cart-item').each(function(){
      var price = $(this).find('.cart-item__totals .price.price--end').html();
      price = parseInt(price.replace('¥', ''));
      total += price;
    });
    return total;
  }

  var main_cart_footer = $.shadowDom('#main-cart-footer');
  if (main_cart_footer.length) {
    $('.cart__ctas').css({'display': 'none'});
    var cartPrices = getCartTotalPrice();
    if (_sp_haspoint >= cartPrices) {
      useCustomerPoint(cartPrices);
    } else {
      //
      var alert_block = $('.cart__footer .cart__blocks .js-contents');
      alert_block.remove();

      var alert_elm = $('<div>');
      alert_elm.addClass('js-contents');
      var alert_elm_under = $('<p>');
      var alert_str = '製品分超過しています。<br>商品を削除してください。';
      var lang = $('html').attr('lang');
      if (lang == 'en') {
        alert_str = 'There is an excess of products.<br>Please delete the product.';
      } else if (lang == 'ko') {
        alert_str = '제품분 초과하고 있습니다.<br>상품을 삭제하세요.';
      } else if (lang == 'zh-CN') {
        alert_str = '产品数量超出。<br>请删除该产品。';
      } else if (lang == 'zh-TW') {
        alert_str = '產品數量超出。<br>請刪除該產品。';
      }

      alert_elm_under.html(alert_str);
      alert_elm_under.css({'color': 'red'});
      alert_elm.append(alert_elm_under);
      $('.cart__footer .cart__blocks').append(alert_elm)
    }

  }



 
});